export default __webpack_public_path__ + "static/media/flag.bb6c6f2f.svg";